import { c as _c } from "react/compiler-runtime";
import { TRACKING_COOKIE_NAME } from '@/analytics/CookieBanner/types';
import useFeatureFlag from '@/analytics/featureFlags/useFeatureFlag';
import { BETTERPLACE_SESSION_COOKIE_NAME } from '@/constants';
import type { DonationFormProps } from '@/donationForm/types';
import { report } from '@/errorReporting';
import analytics, { BOOTSTRAP_DATA_COOKIE_NAME, FeatureFlagKey } from 'product-analytics';
import { useEffect } from 'react';
import Cookies from 'universal-cookie';
const cookies = new Cookies();
function useFeatureFlagLogging(t0) {
  const $ = _c(17);
  const {
    bootstrapData,
    initialFormValues,
    config,
    sessionData,
    phData,
    trackingAcceptedData
  } = t0;
  const clientFF = useFeatureFlag(FeatureFlagKey.FeatureFlagMismatch);
  const initialFF = bootstrapData?.featureFlags?.[FeatureFlagKey.FeatureFlagMismatch];
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cookies.get(BETTERPLACE_SESSION_COOKIE_NAME);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const clientSessionCookie = t1 as string;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cookies.get(`ph_${process.env.NEXT_PUBLIC_POSTHOG_API_KEY}_posthog`);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const clientPosthogCookie = t2 as Record<string, string>;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cookies.get(TRACKING_COOKIE_NAME);
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const clientTrackingAcceptedCookie = t3 as string;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cookies.get(BOOTSTRAP_DATA_COOKIE_NAME);
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const clientBootstrapCookie = t4 as Record<string, string> | undefined;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = analytics.getFeatureFlag("express-checkout");
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const featureFlag = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = analytics.isInitialized();
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const posthogInitialized = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = analytics.getIsEnabled();
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const posthogEnabled = t7;
  let t8;
  let t9;
  if ($[7] !== bootstrapData || $[8] !== clientFF || $[9] !== config || $[10] !== initialFF || $[11] !== initialFormValues || $[12] !== phData || $[13] !== sessionData || $[14] !== trackingAcceptedData) {
    t8 = () => {
      if (clientFF === initialFF) {
        return;
      }
      report("Feature flag mismatch detected: feature-flag-mismatch", {
        bootstrapData,
        clientFF,
        initialFF,
        initialFormValues,
        config,
        sessionData,
        phData,
        trackingAcceptedData,
        clientTrackingCookie: clientTrackingAcceptedCookie,
        clientSessionCookie,
        clientPosthogCookie,
        clientBootstrapCookie,
        featureFlag,
        posthogInitialized,
        posthogEnabled
      });
    };
    t9 = [bootstrapData, clientBootstrapCookie, clientFF, clientPosthogCookie, clientSessionCookie, clientTrackingAcceptedCookie, config, featureFlag, initialFF, initialFormValues, phData, posthogEnabled, posthogInitialized, sessionData, trackingAcceptedData];
    $[7] = bootstrapData;
    $[8] = clientFF;
    $[9] = config;
    $[10] = initialFF;
    $[11] = initialFormValues;
    $[12] = phData;
    $[13] = sessionData;
    $[14] = trackingAcceptedData;
    $[15] = t8;
    $[16] = t9;
  } else {
    t8 = $[15];
    t9 = $[16];
  }
  useEffect(t8, t9);
}
export default useFeatureFlagLogging;